export const genericClientLogoUrl =
  "https://axle-labs-assets.s3.amazonaws.com/clientLogos/generic.svg";

export const STAGE = process.env.REACT_APP_STAGE;

export const IS_LOCAL = process.env.NODE_ENV === "development";

export const CLIENT_ID_PARAM = "client";

export const SENTRY_TAG_CLIENT_ID = "clientId";

export const PLATFORM_ADMIN_AVAILABLE_ROLES = [
  "admin",
  "member",
  "platform-member",
  "platform-analyst",
  "platform-admin",
];
export const ADMIN_AVAILABLE_ROLES = ["admin", "member"];

export const VALIDATION_LOCATION = "validation";
export const SECTION_LOCATION = "section";

// Policy action polling configuration
export const POLL_INTERVAL_MS = 15000; // 15 seconds
export const MAX_POLL_DURATION_MS = 180000; // 3 minutes (e.g. Farmers lienholder flow)

// Policy action toast messages
export const POLICY_ACTION_TOAST_MESSAGES = {
  // When request is initiated and polling begins
  REQUEST_INITIATED:
    "Request to be listed as primary lienholder in progress. This may take up to 3 minutes...",
  // When request fails (initial request or timeout)
  REQUEST_FAILED:
    "Request to be listed as primary lienholder failed. Please try again...",
  // When request succeeds and policy refresh is happening
  REQUEST_SUCCEEDED:
    "Request to be listed as primary lienholder submitted. Refreshing policy information...",
  // When policy refresh fails
  POLICY_REFRESH_FAILED:
    "Refreshing policy information failed. Please reverify or reach out to the carrier...",
  // When policy refresh succeeds
  POLICY_REFRESH_SUCCEEDED:
    "Primary lienholder update request completed, please review the policy...",
};

export const TICK_INTERVAL_MS = 100; // Timer tick frequency for policy-action progress bar

// Phased progress bar configuration (fractions of max timeout)
export const PHASE_1_FRAC = 0.5; // 0–50% of timeout → rapid fill to 75%
export const PHASE_2_FRAC = 0.65; // 50–65% of timeout → hold at 75%
export const PHASE_3_FRAC = 0.85; // 65–85% of timeout → creep from 75% to 85%
// 85–100% of timeout → creep from 85% to 90%
export const PHASE_1_TARGET_PCT = 75;
export const PHASE_2_TARGET_PCT = 75;
export const PHASE_3_TARGET_PCT = 85;
export const PHASE_4_TARGET_PCT = 90;

// Policy action status values
export const POLICY_ACTION_STATUS = {
  REQUEST_INITIATED: "request-initiated",
  REQUEST_SUCCEEDED: "request-succeeded",
  REQUEST_FAILED: "request-failed",
  EXPIRED: "expired",
  POLICY_REFRESH_FAILED: "policy-refresh-failed",
  POLICY_REFRESH_SUCCEEDED: "policy-refresh-succeeded",
};

export const RESOURCE_ROUTE_PATTERN =
  /^\/(ignition|policies)\/[^/]+|^\/team\/invite/;

// Carrier coverage dashboard — status model
export const CARRIER_STATUS = {
  ACTIVE: "active",
  ACTIVE_BASIC: "active-basic",
  INACTIVE: "inactive",
  UNSUPPORTED: "unsupported",
};

// Sentinel filter value used by the "All / User portal / Policy lookup"
export const CARRIER_STATUS_SUPPORTED_FILTER = "supported";

// Axle docs — the fields policy lookup requires for each policy type
export const POLICY_LOOKUP_DOCS_URL =
  "https://docs.axle.insure/guides/proxy-ignition#supported-operations";
